var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col border border-gray-200 gap-4 rounded-2xl p-5"},[_c('h2',{staticClass:"font-medium text-gray-400 mb-4"},[_vm._v("Montant du CA")]),(_vm.isLoaded)?_c('counter',{attrs:{"value":_vm.value}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }